document.addEventListener('DOMContentLoaded', function () {
  var container = document.getElementById('countdown');
  if (!container) return;

  // Read deadline from data attribute; fallback
  var deadlineString = container.getAttribute('data-deadline') || '2026-12-31T09:30:00';
  var deadline = deadlineString ? new Date(deadlineString) : false;

  // CountdownTracker class
  function CountdownTracker(label) {
    this.el = container.querySelector('.flip-clock__piece[data-unit="' + label + '"]');
    var top = this.el.querySelector('.card__top'),
        bottom = this.el.querySelector('.card__bottom'),
        back = this.el.querySelector('.card__back'),
        backBottom = this.el.querySelector('.card__back .card__bottom');

    this.currentValue = -1;

    // Update the flipping cards
    this.update = function (val) {
      val = ('0' + val).slice(-2);
      if (val !== this.currentValue) {
        if (this.currentValue >= 0) {
          back.setAttribute('data-value', this.currentValue);
          bottom.setAttribute('data-value', this.currentValue);
        }
        this.currentValue = val;
        top.innerText = this.currentValue;
        backBottom.setAttribute('data-value', this.currentValue);

        this.el.classList.remove('flip');
        void this.el.offsetWidth;
        this.el.classList.add('flip');
      }
    };

    // Hide or show the entire flip clock piece
    this.setVisibility = function(show) {
      if (this.el) this.el.style.display = show ? 'inline-block' : 'none';
    };
  }

  // Calculate remaining time
  function getTimeRemaining(endtime) {
    var t = Date.parse(endtime) - Date.parse(new Date());
    return {
      Total: t,
      Days: Math.floor(t / (1000 * 60 * 60 * 24)),
      Hours: Math.floor((t / (1000 * 60 * 60)) % 24),
      Minutes: Math.floor((t / 1000 / 60) % 60),
      Seconds: Math.floor((t / 1000) % 60)
    };
  }

  // Initialize the clock
  function Clock(countdown) {
    var updateFn = getTimeRemaining;
    var trackers = {}, t = updateFn(countdown), timeinterval;

    // Create trackers for each unit
    for (var key in t) {
      if (key === 'Total') continue;
      trackers[key] = new CountdownTracker(key);
    }

    // Animate clock
    var i = 0;
    function updateClock() {
      timeinterval = requestAnimationFrame(updateClock);
      if (i++ % 10) return; // throttle animation

      var t = updateFn(countdown);
      if (t.Total < 0) {
        cancelAnimationFrame(timeinterval);
        for (var key in trackers) trackers[key].update(0);
        return;
      }

      // Hide Days piece if < 1 day
      if (trackers['Days']) trackers['Days'].setVisibility(t.Days > 0);

      // Hide Hours piece if < 1 hour
      if (trackers['Hours']) trackers['Hours'].setVisibility(t.Days > 0 || t.Hours > 0);

      // Update all trackers
      for (var key in trackers) trackers[key].update(t[key]);
    }

    setTimeout(updateClock, 500);
  }

  if (deadline) new Clock(deadline);
});
